export const TAGS_SECTION_ID_SELECTOR = 'tags-enhancement';
export const TAGS_AUTOCOMPLETE_LIST_HEADER = 'Suggestions';
